export default {
  header: 1000,
  tooltip: 1100,
  drawer: 1300,
  modal: 1400,
  popover: 1500,
  toast: 1600,
  raised: 100,
}
